module.exports = __webpack_public_path__ + "static/img/yi.1745385299907.png";